import { PerformanceReport } from "components/Report/PerformanceReport/PerformanceReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser";
import { PermissionEnum, RoleEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/performance/")({
    component: PerformanceReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportPerformance],
        showInSideMenu: false,
        label: "pages.report.performance.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.performance.title"),
        };
    },
});

function PerformanceReportPage() {
    const userUtils = useUser();
    const { t } = usePaldockTranslation("pages.report.performance");
    if (
        //TODO roles -> permissions
        userUtils
            ?.getActiveTenant()
            ?.userRoles?.some((role) => [RoleEnum.AffiliateManager, RoleEnum.AffiliateManager].includes(role.name))
    ) {
        return (
            <TenantPage headerNavigationItems={getReportHeaderItems}>
                <PerformanceReport userId={userUtils.getAuthenticatedUser()?.id} />
            </TenantPage>
        );
    } else {
        return (
            <TenantPage headerNavigationItems={getReportHeaderItems} title={t("title")}>
                <PerformanceReport />
            </TenantPage>
        );
    }
}
